import dayjs from "dayjs";
import tz from "dayjs/plugin/timezone";

dayjs.extend(tz);

// We default to Hong Kong time. If a user is specifically viewing Melbourne or DGC,
// this should ideally be passed in as a parameter based on the selected hotel, 
// but for backward compatibility we will default to HK.
const timezone = "Asia/Hong_Kong";
console.log({ timezone });

const formatDate = (date, tz = timezone) => {
  return dayjs(date).startOf("day").tz(tz).format("YYYY-MM-DD HH:mm:ss");
};

export default formatDate;
